import { render, staticRenderFns } from "./candidatesItemWidget.vue?vue&type=template&id=2e2700ac&scoped=true"
import script from "./candidatesItemWidget.vue?vue&type=script&lang=js"
export * from "./candidatesItemWidget.vue?vue&type=script&lang=js"
import style0 from "./candidatesItemWidget.vue?vue&type=style&index=0&id=2e2700ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2700ac",
  null
  
)

export default component.exports